export const NAME_MAX = 20;
export const MESSAGE_MAX = 500;
export const PHONE_LENGTH = 10;

export const NAME_PATTERN = /^[A-Za-z ]*$/;
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_PATTERN = new RegExp(`^\\d{${PHONE_LENGTH}}$`);
